import { Tabs } from 'material-ui/Tabs';

export default Tabs;
